import { inject, Injectable } from '@angular/core';
import { DalState, FavoriteQueries, ProductInterface } from '@campus/dal';
import { FavoriteTypesEnum } from '@campus/environment';
import {
  BOOKS_TILE_SERVICE_TOKEN,
  BooksTileActionHandlerInterface,
  BooksTileComponentInterface,
  BooksTileServiceInterface,
} from '@campus/shared';
import { groupArrayByKeys } from '@campus/utils';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

@Injectable()
export class PolpoFavoriteBooksService {
  private store: Store<DalState> = inject(Store);
  private booksTileService: BooksTileServiceInterface = inject(BOOKS_TILE_SERVICE_TOKEN);

  public getFavoriteBooks$(
    booksTileActionHandler?: BooksTileActionHandlerInterface
  ): Observable<BooksTileComponentInterface[]> {
    return this.store.pipe(
      select(FavoriteQueries.getByType, { type: FavoriteTypesEnum.BOOK }),
      switchMap((bookFavorites) => {
        const favoritesByProductByBookId = groupArrayByKeys(bookFavorites, ['productId', 'eduContentBookId']);
        return this.booksTileService.getBookTiles$<ProductInterface>(null, {
          filterEmptyTiles: true,
          rowFilter: (book, product) => favoritesByProductByBookId[product.id]?.[book.id],
          actionHandler: booksTileActionHandler,
          allowedActions: ['toc', 'boeke'],
          rowSortComparer: (a, b) => a.data.displayOrder - b.data.displayOrder,
        });
      }),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
  }
}
